export async function sliceData(startingItems, slicedHeadersRef) {
  console.log({ slicedHeadersRef })
  let result = startingItems

  slicedHeadersRef.forEach(headerRef => {
    let { header, items } = headerRef.get()
    if (header.value) {
      result = result.filter(item => {
        let datum = item[header.value]
        if (header.format) datum = header.format(datum)
        if (datum instanceof Array) {
          if (datum.length == 0) return items[null]
          return datum.some(value => items[value])
        } else {
          return items[datum]
        }
      })
    }
  })

  return result
}